// A saved draft remains browseable. Only entering a brand-new campaign is
// intercepted; company access and role enforcement remain server-owned.
export function newCampaignSelection(path) {
  if (typeof path !== 'string') return null;
  const value = path.replace(/^#\/?/, '').replace(/^\//, '');
  const [route, query = ''] = value.split('?');
  if (route.replace(/\/+$/, '') !== 'curated-campaign') return null;
  const requested = new URLSearchParams(query).get('types') || '';
  return [...new Set(requested.split(',').filter(key => /^[a-z][a-z0-9_]{0,63}$/.test(key)))].slice(0, 100);
}
